module.exports = __webpack_public_path__ + "img/part1.1a18115b.png";